import { Injectable } from '@angular/core';

@Injectable()
export class StorageService {
  private validateStorage(storage: Storage) {
    if (!storage) {
      throw new Error('Missing Storage');
    }
  }

  delete(storage: Storage, key: string): void {
    this.validateStorage(storage);
    storage.removeItem(key);
  }

  deleteStorage(storage: Storage): void {
    this.validateStorage(storage);
    storage.clear();
  }

  async fetch(storage: Storage, key: string): Promise<string | null> {
    this.validateStorage(storage);
    if (!key) {
      throw new Error('Missing Key');
    }
    return storage.getItem(key);
  }

  store(storage: Storage, key: string, data: string): void {
    this.validateStorage(storage);
    if (data == null || key == null) {
      console.warn('Missing Key/Value pair definition');
      return;
    }
    storage.setItem(key, data);
  }
}
